import React from 'react';
import SwitchButton from 'Components/Elements/Buttons/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { selectViewTypeFilterOption } from 'core/redux/features/shared/reducers';
import { AppState } from 'core/redux/reducers';
import sharedActions from 'core/redux/features/shared/actions';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';

export const ChangeViewTypeButton = () => {
  const viewTypes = useSelector(selectViewTypeFilterOption);
  const activeViewType = useSelector(
    (state: AppState) => state.viewTypes.activeViewType,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const onChangeView = (e: React.SyntheticEvent, type: string) => {
    e.preventDefault();
    if (type === activeViewType) {
      return;
    }

    dispatch(sharedActions.changeView(type));

    const find = viewTypes.find(v => v.id === type);
    if (find && find.route) {
      location.pathname = find.route;
      history.push(location);
    }
  };

  return (
    <SwitchButton
      className="item has-letter-space switch-city is-pulled-right"
      options={viewTypes}
      selected={activeViewType}
      onSelect={onChangeView}
    />
  );
};
